class FreeProductAndGifts {
  constructor() {

  }

  async checkFreeProductAndGifts() {
    this.#showOverlay();

    try {
      const cart = await this.#fetchCart();
      const updates = this.#buildCartUpdates(cart);

      // Single endpoint call for all gift changes
      if (Object.keys(updates).length > 0) {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });

        if (!response.ok) throw new Error(`cart/update.js error: ${response.status}`);
        const updatedCart = await response.json();

        if (updatedCart.total_price === 0) {
          document.querySelector('cart-drawer')?.classList.add('is-empty');
        }
      }

      // Single re-render after all changes are applied
      await Promise.all([
        this.#renderCartDrawer(),
        this.#renderMainCart(),
      ]);

    } catch (e) {
      console.error('checkFreeProductAndGifts error:', e);
    } finally {
      this.#hideOverlay();
    }
  }



  /* ── Overlay ──────────────────────────────────────────────────────────── */

  #showOverlay() {


    const overlay = document.querySelectorAll('[id="CartDogOverlay"]');

    if (overlay.length > 0) {
      overlay.forEach(overlay => {
        // Perform your actions here
        overlay.classList.add('is-visible');
      });

    }
  }

  #hideOverlay() {
    const overlay = document.querySelectorAll('[id="CartDogOverlay"]');

    if (overlay.length > 0) {
      overlay.forEach(overlay => {
        // Perform your actions here
        overlay.classList.remove('is-visible');
      });

    }
  }

  /* ── Fetch helpers ────────────────────────────────────────────────────── */

  async #fetchCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    if (!response.ok) throw new Error(`cart.js error: ${response.status}`);
    return response.json();
  }

  async #renderCartDrawer() {
    const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    for (const selector of ['.cart-drawer', 'cart-drawer-items', 'cart-progressbar']) {
      const target = document.querySelector(selector);
      const source = html.querySelector(selector);
      if (target && source) target.replaceWith(source);
    }
  }

  async #renderMainCart() {
    const response = await fetch(`${routes.cart_url}`);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    for (const selector of ['cart-items', '.cart__footer', '.cart-count-bubble']) {
      const target = document.querySelector(selector);
      const source = html.querySelector(selector);
      if (target && source) target.replaceWith(source);
    }
  }

  #buildCartUpdates(cart) {
    const updates = {};
    const cont = document.querySelector('.shipping-progress-cont');
    if (!cont) return updates;

    const gifts = [
      {
        variantId: cont.dataset.smallGift,
        productId: cont.dataset.smallGiftProductId,
        threshold: parseInt(cont.dataset.smallGiftThresholdPrice),
      },
      {
        variantId: cont.dataset.bigGift,
        productId: cont.dataset.bigGiftProductId,
        threshold: parseInt(cont.dataset.bigGiftThresholdPrice),
      },
    ];

    const cartTotal = cart.total_price;

    for (const gift of gifts) {
      if (!gift.variantId || !gift.threshold) continue;

      const id = parseInt(gift.variantId);
      const productId = parseInt(gift.productId);
      const onCart = cart.items.find(
        item => item.id === id || item.product_id === productId
      );

      if (cartTotal >= gift.threshold) {
        // Should be in cart at qty 1
        if (!onCart) {
          updates[id] = 1;          // add
        } else if (onCart.quantity !== 1) {
          updates[onCart.id] = 1;   // correct quantity
        }
        // already qty 1 — no change needed
      } else {
        // Should not be in cart
        if (onCart) {
          updates[onCart.id] = 0;   // remove
        }
      }
    }

    return updates;
  }
}